"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const country_entity_1 = require("./country.entity");
let State = class State {
    constructor(name, country, stateCode) {
        this.name = name;
        this.country = country;
        this.stateCode = stateCode;
    }
};
exports.State = State;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], State.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", type: "varchar", length: 100 }),
    tslib_1.__metadata("design:type", String)
], State.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "state_code", type: "varchar", length: 10, nullable: true }),
    tslib_1.__metadata("design:type", String)
], State.prototype, "stateCode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => country_entity_1.Country, (country) => country.id),
    (0, typeorm_1.JoinColumn)({ name: "country_id" }) // Ensure the correct column name is used
    ,
    tslib_1.__metadata("design:type", typeof (_b = typeof country_entity_1.Country !== "undefined" && country_entity_1.Country) === "function" ? _b : Object)
], State.prototype, "country", void 0);
exports.State = State = tslib_1.__decorate([
    (0, typeorm_1.Entity)("state"),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_a = typeof country_entity_1.Country !== "undefined" && country_entity_1.Country) === "function" ? _a : Object, String])
], State);
